
import { Panel } from "./styled"
import Heading from "./Heading"

const Step = ({ title, children, ...props }) => {
  return <section className="text-center">
    <Heading>{title}</Heading>
    <Panel {...props}>{children}</Panel>
  </section>
}

export default Step
